<template>
  <div class="">
    <v-container>
      <v-form
        ref="form"
        v-model="internalValid"
        lazy-validation
      >
        <v-row>
          <v-col
            cols="12"
            class="mb-1"
          >
            <SmallSectionTitle
              section-number="1"
              :title="$t('main.enums.sections.bank_infos')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="displayField['account_iban']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.account_iban"
              :required="requiredField['account_iban']"
              :rules="fieldRules['account_iban']"
              :label="$t('main.enums.fields.account_iban')"
              :default="record.account_iban"
              clear-on-focus
              @input="removeFieldErrors('account_iban')"
            />
          </v-col>
          <v-col
            v-if="displayField['bank_bic']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.bank_bic"
              :required="requiredField['bank_bic']"
              :rules="fieldRules['bank_bic']"
              :label="$t('main.enums.fields.bank_bic')"
              :default="record.bank_bic"
              @input="removeFieldErrors('bank_bic')"
            />
          </v-col>
          <v-col
            v-if="displayField['account_holder']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.account_holder"
              :required="requiredField['account_holder']"
              :rules="fieldRules['account_holder']"
              :label="$t('main.enums.fields.account_holder')"
              :default="record.account_holder"
              @input="removeFieldErrors('account_holder')"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import { getFieldsByProperty } from '@/utils/person.utils'

  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'
  import TextInput from '@/components/ui/inputs/TextInput'
  import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'

  export default {
    components: {
      SmallSectionTitle,
      TextInput,
    },
    mixins: [mixinUi, CommonMixin,],
    props: {
      formValid: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        valid: true,
        localFields: personTabFields.bank,
        record: {},
      }
    },
    computed: {
      internalValid: {
        get() {
          return this.formValid
        },
        set(value) {
          return this.$emit('update:formValid', value)
        },
      },
      displayField() {
        const allFields = this.requiredAttributes.concat(this.optionalAttributes)

        return getFieldsByProperty(allFields, this.localFields)
      },
      requiredField() {
        return getFieldsByProperty(this.requiredAttributes, this.localFields)
      },
      fieldRules() {
        const rules = {}

        this.localFields.forEach((item) => {
          rules[item] = []
          if (this.formErrors[item]) {
            rules[item].push(this.$t(`main.enums.error.${this.formErrors[item]}`))
          }
        })

        return rules
      },
    },
    watch: {
      formErrors: function(val) {
        this.$refs.form.validate()
      },
    },
    mounted() {
      this.record = Object.assign({}, this.selectedProfile)
      if (Object.keys(this.formErrors).length > 0) {
        this.$refs.form.validate()
      }
    },
    methods: {
      getRecord() {
        return this.record
      },
    },
  }
</script>

<style scoped lang="scss">
.description {
  font-size: 16px;
  color: $color-a9a4a4;
}
</style>
